/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ItemCodeEnum } from '../models/item-code-enum';
import { PurchaseDto } from '../models/purchase-dto';
import { PurchaseResultDto } from '../models/purchase-result-dto';

@Injectable({
  providedIn: 'root',
})
export class PurchaseService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listPurchases
   */
  static readonly ListPurchasesPath = '/purchases';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listPurchases()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPurchases$Response(params?: {
    code?: ItemCodeEnum;
    itemId?: string;
  }): Observable<StrictHttpResponse<Array<PurchaseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PurchaseService.ListPurchasesPath, 'get');
    if (params) {
      rb.query('code', params.code, {});
      rb.query('itemId', params.itemId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PurchaseDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listPurchases$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPurchases(params?: {
    code?: ItemCodeEnum;
    itemId?: string;
  }): Observable<Array<PurchaseDto>> {

    return this.listPurchases$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PurchaseDto>>) => r.body as Array<PurchaseDto>)
    );
  }

  /**
   * Path part for operation purchase
   */
  static readonly PurchasePath = '/purchases';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `purchase()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  purchase$Response(params: {
    body: Array<PurchaseDto>
  }): Observable<StrictHttpResponse<PurchaseResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, PurchaseService.PurchasePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PurchaseResultDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `purchase$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  purchase(params: {
    body: Array<PurchaseDto>
  }): Observable<PurchaseResultDto> {

    return this.purchase$Response(params).pipe(
      map((r: StrictHttpResponse<PurchaseResultDto>) => r.body as PurchaseResultDto)
    );
  }

}
